import { connect } from 'react-redux';
import { findAdminShopUser } from '../shops/selectors';

const withAdminShopUser = connect((state, props) => ({
  adminShopUser: findAdminShopUser(state, props.shopId),
}));

export default withAdminShopUser;
